'use client';

import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { encodePassphrase, randomString } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';

export default function Page() {
  const router = useRouter();
  const [e2ee, setE2ee] = useState(false);
  const [sharedPassphrase, setSharedPassphrase] = useState(randomString(64));

  const onSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target as HTMLFormElement);
    const roomName = String(formData.get('roomName') || '').trim();
    const participantName = String(formData.get('participantName') || '').trim();

    if (!roomName || !participantName) {
      return;
    }

    let url = `/rooms/${encodeURIComponent(roomName)}?participantName=${encodeURIComponent(
      participantName,
    )}`;
    if (e2ee) {
      url = `${url}#${encodePassphrase(sharedPassphrase)}`;
    }
    router.push(url);
  };

  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <div className="header">
          <img src="/images/livekit-meet-home.svg" alt="LiveKit Meet" width="360" height="45" />
          <h2>Видео-звонки Khimach на LiveKit</h2>
        </div>
        <form className={styles.tabContent} onSubmit={onSubmit}>
          <p style={{ marginTop: 0 }}>
            Подключение к комнатам через собственный сервер LiveKit на dev.khimach.su.
          </p>
          <input
            id="roomName"
            name="roomName"
            type="text"
            placeholder="Название комнаты"
            required
          />
          <input
            id="participantName"
            name="participantName"
            type="text"
            placeholder="Ваше имя"
            required
          />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
              <input
                id="use-e2ee"
                type="checkbox"
                checked={e2ee}
                onChange={(ev) => setE2ee(ev.target.checked)}
              />
              <label htmlFor="use-e2ee">Включить сквозное шифрование</label>
            </div>
            {e2ee && (
              <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                <label htmlFor="passphrase">Пароль комнаты</label>
                <input
                  id="passphrase"
                  type="password"
                  value={sharedPassphrase}
                  onChange={(ev) => setSharedPassphrase(ev.target.value)}
                />
              </div>
            )}
          </div>
          <hr
            style={{
              width: '100%',
              borderColor: 'rgba(255, 255, 255, 0.15)',
              marginBlock: '1rem',
            }}
          />
          <button
            style={{ paddingInline: '1.25rem', width: '100%' }}
            className="lk-button"
            type="submit"
          >
            Войти в комнату
          </button>
        </form>
      </main>
      <footer data-lk-theme="default">
        Source code on{' '}
        <a href="https://github.com/livekit/meet?ref=meet" rel="noopener">
          GitHub
        </a>
        .
      </footer>
    </>
  );
}
